import './EncryptedWarning.scss';
import { ReactElement } from 'react';

interface IEncryptedWarning {
  text: string;
}

export const EncryptedWarning = ({ text }: IEncryptedWarning): ReactElement => <span className='encrypted-warning'>{text}</span>;
